import { useRef, useState } from "react";
import { toast } from "sonner";
import { ScanLine, Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { contractsApi } from "../../lib/contractsApi";

// Manager uploads the other party's scanned signature (image/PDF); background is removed server-side.
export const ContractUploadSign = ({ contract, onChange }) => {
  const [name, setName] = useState(contract.party_name || "");
  const [busy, setBusy] = useState(false);
  const inp = useRef(null);
  if (contract.status === "signed" || !contract.id) return null;
  const pick = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = "";
    if (!f) return;
    if (!window.confirm(`اعتماد العقد كموقّع من «${name || "الطرف الثاني"}» بالتوقيع المرفوع؟ لن يمكن تعديله بعدها.`)) return;
    setBusy(true);
    try { onChange(await contractsApi.uploadSignature(contract.id, f, name)); toast.success("تم رفع التوقيع واعتماد العقد كموقّع"); }
    catch (err) { toast.error(err?.response?.data?.detail || "تعذّر رفع التوقيع"); } finally { setBusy(false); }
  };
  return (
    <div className="rounded-2xl border border-emerald-200 bg-emerald-50/50 p-3 space-y-2" data-testid="contract-upload-sign">
      <p className="text-sm font-bold text-emerald-800 flex items-center gap-1.5"><ScanLine className="h-4 w-4" /> رفع توقيع الموظف (اسكنر / ملف)</p>
      <p className="text-[11px] text-slate-600">صورة أو PDF للتوقيع على ورق — تُزال الخلفية تلقائياً ويوضع التوقيع في خانة الطرف الثاني.</p>
      <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="اسم الموقّع" className="h-9 bg-white" data-testid="contract-upload-sign-name" />
      <input ref={inp} type="file" accept="image/*,application/pdf,.pdf" className="hidden" onChange={pick} data-testid="contract-upload-sign-input" />
      <Button onClick={() => inp.current?.click()} disabled={busy} variant="outline" className="w-full gap-1.5 border-emerald-300 bg-white text-emerald-700 hover:bg-emerald-50" data-testid="contract-upload-sign-btn">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <ScanLine className="h-4 w-4" />} {busy ? "جارٍ المعالجة…" : "اختر ملف التوقيع"}
      </Button>
    </div>
  );
};
